module.exports = __webpack_public_path__ + "static/media/investors-business-daily.d4ce0285.png";